import { CurrencyPipe } from '@angular/common';
import { Column, GridRow } from '@shared';

// Every column filters with the checkbox list of app-custom-filter, declared as
// a filterTemplate on zero-price-report.component.html, instead of asking for an
// operator (Contains, Is equal to, ...) before the value.
class ZeroPrice {
  @Column({
    title: 'Tier',
    field: 'tierName',
    order: 0,
    width: 80,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    sortable: true,
    align: 'left',
  })
  tierName?: string;

  @Column({
    title: 'Restaurant',
    field: 'restaurantNo',
    order: 0.1,
    width: 100,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    sortable: true,
    align: 'left',
  })
  restaurantNo?: string;

  @Column({
    title: 'Category',
    field: 'category',
    order: 0.2,
    width: 100,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    sortable: true,
    align: 'left',
  })
  category?: string;

  @Column({
    title: 'Product',
    field: 'itemName',
    order: 0.3,
    width: 150,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    fixed: true,
    align: 'left',
    sortable: true,
    visibleInQuickView: true,
  })
  itemName?: string;

  @Column({
    title: 'Component',
    field: 'componentName',
    order: 0.4,
    width: 150,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    align: 'left',
    sortable: true,
    visibleInQuickView: true,
  })
  componentName?: string;

  @Column({
    title: 'Component Type',
    field: 'componentType',
    order: 0.5,
    width: 100,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    align: 'left',
    sortable: true,
  })
  componentType?: string;

  @Column({
    field: 'currentPrice',
    title: 'Current Price',
    order: 0.7,
    pipeToken: CurrencyPipe,
    width: 80,
    filterable: true,
    filterType: 'numeric',
    sortable: true,
    visibleInQuickView: true,
  })
  currentPrice?: number;

  @Column({
    title: 'Brink ID',
    field: 'parItemId',
    order: 0.8,
    width: 90,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    sortable: true,
  })
  parItemId?: string;

  @Column({
    field: 'plu',
    title: 'PLU',
    order: 0.9,
    width: 60,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    sortable: true,
    visibleInQuickView: true,
  })
  plu?: string;

  constructor(
    tierName?: string,
    restaurantNo?: string,
    category?: string,
    itemName?: string,
    componentName?: string,
    componentType?: string,
    currentPrice?: number,
    parItemId?: string,
    plu?: string,
  ) {
    this.tierName = tierName;
    this.restaurantNo = restaurantNo;
    this.category = category;
    this.itemName = itemName;
    this.componentName = componentName;
    this.componentType = componentType;
    this.currentPrice = currentPrice;
    this.parItemId = parItemId;
    this.plu = plu;
  }
}

export class GridRowZeroPrice extends GridRow(ZeroPrice) {}
